import React, { useEffect, useRef, useState } from 'react'
import ball_img from "../../../assets/images/ball.png"
import quote_img from "../../../assets/images/quote.png"
import brush_img from "../../../assets/images/brush.png"
import User1 from "../../../assets/images/Testimonial1.jpg"
import Slider from 'react-slick'
import { axiosInstance } from '../config'

const ClientTestimonials = () => {

    const sliderRef = useRef(null)
    const settings = {
        dots: true,
        fade: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: true,
    };

    const [testimonial, settestimonial] = useState([])

    useEffect(() => {
        window.scroll(0, 0);
        getData();
    }, [])

    const getData = async () => {
        axiosInstance.get(`/testimonials`)
            .then(res => {
                settestimonial(res?.data?.Testimonial);  // Set the modified services with icons
            })
            .catch((err) => console.log(err))
            .finally(() => {
            });
    }

    return (
        <>
            <div
                id="rs-testimonial"
                className="rs-testimonial testimonial-style2 blue-bg pt-120 pb-120 md-pt-80 md-pb-80"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 md-mb-50">
                            <div className="sec-title2">
                                <div className="brush-content mb-20">
                                    <img src={brush_img} alt="" />
                                    <span className="sub-text yellow-color"> Testimonials</span>
                                </div>
                                <h2 className="title white-color pb-25">
                                    What Our Clients <br />
                                    Say About Us
                                </h2>
                                <p className="desc white-color mt-4">
                                    Discover What Our Clients Say About Us: Genuine Testimonials Showcasing Precision and Excellence in Cleaning 
                                </p>
                            </div>

                            <div>
                                <div className="slider-btns  mt-5">
                                    <button onClick={() => sliderRef?.current?.slickPrev()}>
                                        <i className="bi bi-arrow-left-short fs-3"></i>
                                    </button>
                                    <button onClick={() => sliderRef?.current?.slickNext()}>
                                        <i className="bi bi-arrow-right-short fs-3"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 pr-40 md-pr-15"
                            style={{
                                position: 'relative',
                                zIndex: '10'
                            }}
                        >
                            <Slider {...settings} ref={sliderRef}>
                                {
                                    testimonial.map((review, i) => {
                                        return (
                                            <div className="testi-item" key={i + 'test'}>
                                                <div className="testi-wrap">
                                                    <div className="images-wrap">
                                                        <img
                                                            src={review?.imageUrl}
                                                            align="Images"
                                                        />
                                                    </div>
                                                    <div className="item-content-basic">
                                                        <span className='d-md-inline d-none'>
                                                            <img
                                                                src={quote_img}
                                                                alt="Images"
                                                            />
                                                        </span>
                                                        <p>
                                                            “{review?.description}”
                                                        </p>
                                                        <div className="testi-information">
                                                            <div className="testi-name">{review?.name}</div>
                                                            <span className="designation">{review?.services?.name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </Slider>

                        </div>
                    </div>
                </div>
                <div className="testi-animation">
                    <div className="animate-style one">
                        <img
                            className="rotated-style2"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style two">
                        <img
                            className="scale"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style three">
                        <img
                            className="rotated-style2"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style four">
                        <img
                            className="scale"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style five">
                        <img
                            className="rotated-style2"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style six">
                        <img
                            className="scale"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style seven">
                        <img
                            className="scale"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                    <div className="animate-style eight">
                        <img
                            className="rotated-style2"
                            src={ball_img}
                            alt="Images"
                        />
                    </div>
                </div>
            </div>

        </>
    )
}

export default ClientTestimonials